import { render, staticRenderFns } from "./DataInsightTable.vue?vue&type=template&id=680e8066&scoped=true&"
import script from "./DataInsightTable.vue?vue&type=script&lang=js&"
export * from "./DataInsightTable.vue?vue&type=script&lang=js&"
import style0 from "./DataInsightTable.vue?vue&type=style&index=0&id=680e8066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e8066",
  null
  
)

export default component.exports